'use client';

import { motion } from 'framer-motion';
import { useSafeNavigation } from '@/hooks/useSafeNavigation';
import { useModalStore } from '@/stores/useModalStore';
import ImageAdaptive from '@/components/ImageAdaptive';
import PrivacyPolicy from '@/(routers)/(entry)/inquiry/components/modal/PrivacyPolicy';

export default function Inquiry() {
    const { safePush } = useSafeNavigation();
    const { openModal } = useModalStore();

    return (
        <div className="flex flex-col justify-start items-center w-full font-notojp font-color-black-base">
            <div className="flex flex-col w-full xl:w-[90%] 2xl:w-[80%]">
                <div className="flex justify-start items-center font-corp font-bold text-3xl p-4 min-h-[60px] md:min-h-[75px]">
                    <ImageAdaptive src="/images/common/schoomy.png" baseWidth={150} breakpoints={{ md: 180 }} />
                </div>
                <div className="flex justify-center items-start w-full pt-2 pb-2 font-montserrat font-black text-color-base-2 text-[40px] xl:text-[60px] tracking-widest">
                    INQUIRY
                </div>
                <div className="flex justify-center items-start w-full pb-20 font-bold text-gray-400 text-xl xl:text-[25px] tracking-widest">
                    お問い合わせ
                </div>
                <div className="flex flex-col xl:flex-row justify-center xl:justify-start items-center xl:items-start rounded-xl bg-color-white-base border border-color-white-base w-full pb-12">
                    <div className="relative flex flex-col justify-center items-start w-[80%] xl:w-[49%] tracking-widest rounded-3xl bg-color-base-1 pt-8">
                        <motion.div
                            initial={{ y: -50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{
                                type: 'spring',
                                stiffness: 200,
                                damping: 10,
                                delay: 0.5,
                            }}
                            className="absolute -top-10 xl:-top-8 left-4 xl:left-8"
                        >
                            <ImageAdaptive src="/images/inquiry/support.svg" baseWidth={70} breakpoints={{ md: 100 }} />
                        </motion.div>
                        <div className="flex justify-center w-full font-bold text-color-black-base text-xl xl:text-3xl pb-2">
                            製品・サービス
                        </div>
                        <div className="flex justify-center w-full font-medium text-color-black-base text-sm xl:text-base pb-12">
                            に関するお問い合わせ
                        </div>
                        <div className="flex flex-col justify-center items-center w-full xl:h-[150px] font-medium text-sm pb-8">
                            <div className="flex flex-col xl:grid xl:grid-cols-2 xl:gap-2 justify-center pb-0 xl:pb-4">
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-[280px] xl:w-auto">
                                    スクーミー導入に関するご相談
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-full xl:w-auto">
                                    導入後のサポート
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                            </div>
                            <div className="flex flex-col xl:grid xl:grid-cols-3 xl:gap-2 justify-center">
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-[280px] xl:w-auto">
                                    製品のご利用方法
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-full xl:w-auto">
                                    サービス内容のご説明
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-full xl:w-auto">
                                    技術関連のご相談
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                            </div>
                        </div>
                        <div className="flex justify-center w-full font-medium text-sm pb-8">
                            <button
                                className="m-2 py-4 px-12 bg-color-base-2 font-notojp font-bold text-color-white-base rounded-3xl shadow-right-bottom hover:opacity-90 whitespace-nowrap"
                                onClick={() => {
                                    safePush(`/inquiry/form/support`);
                                }}
                            >
                                問い合わせる
                            </button>
                        </div>
                    </div>
                    <div className="flex-grow w-[2%] py-8"></div>
                    <div className="relative flex flex-col justify-center items-start w-[80%] xl:w-[49%] tracking-widest rounded-3xl bg-gray-200 pt-8">
                        <motion.div
                            initial={{ y: -50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{
                                type: 'spring',
                                stiffness: 200,
                                damping: 10,
                                delay: 1.0,
                            }}
                            className="absolute -top-10 xl:-top-8 left-4 xl:left-8"
                        >
                            <ImageAdaptive
                                src="/images/inquiry/business.svg"
                                baseWidth={70}
                                breakpoints={{ md: 100 }}
                            />
                        </motion.div>
                        <div className="flex justify-center w-full font-bold text-color-black-base text-xl xl:text-3xl pb-2">
                            営業担当者
                        </div>
                        <div className="flex justify-center w-full font-medium text-color-black-base text-sm xl:text-base pb-12">
                            へのお問い合わせ
                        </div>
                        <div className="flex flex-col justify-center items-center w-full xl:h-[150px] font-medium text-sm pb-8">
                            <div className="flex flex-col xl:grid xl:grid-cols-1 xl:gap-2 justify-center pb-0 xl:pb-4">
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-[280px] xl:w-auto">
                                    月刊みんなのダイブ購入のご相談
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                            </div>
                            <div className="flex flex-col xl:grid xl:grid-cols-2 xl:gap-2 justify-center pb-0 xl:pb-4">
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-[280px] xl:w-auto">
                                    お見積りのご依頼
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-full xl:w-auto">
                                    代理店契約のご相談
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                            </div>
                            <div className="flex flex-col xl:grid xl:grid-cols-2 xl:gap-2 justify-center">
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-[280px] xl:w-auto">
                                    メディアの取材・掲載のご相談
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                                <div className="flex justify-center bg-color-white-base rounded-3xl px-4 py-1 w-full xl:w-auto">
                                    イベントの共催・協賛のご相談
                                </div>
                                <div className="py-2 xl:py-0 block xl:hidden"></div>
                            </div>
                        </div>
                        <div className="flex justify-center w-full font-medium text-sm pb-8">
                            <button
                                className="m-2 py-4 px-12 bg-color-black-base font-notojp font-bold text-color-white-base rounded-3xl shadow-right-bottom hover:opacity-80 whitespace-nowrap"
                                onClick={() => {
                                    safePush(`/inquiry/form/business`);
                                }}
                            >
                                問い合わせる
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="flex justify-center cursor-pointer text-xs text-color-base-2 pb-8"
                onClick={() =>
                    openModal({
                        id: 'inquiry-privacy-policy',
                        component: <PrivacyPolicy />,
                        size: {
                            pcWidth: '800px',
                            mbWidth: '90%',
                            pcHeight: '620px',
                            mbHeight: '80%',
                        },
                        direction: 'clip',
                        overFlowType: 'auto',
                    })
                }
            >
                <div>|</div>
                <div className="px-4">プライバシーポリシー</div>
                <div>|</div>
            </div>
        </div>
    );
}
